import { Node, mergeAttributes } from '@tiptap/core';

import { DefaultRentalAgreementTemplate } from './default-rental-agreement-template';

export const PlaceholderExtension = (editor: any) =>
  Node.create({
    name: 'placeholder',
    group: 'inline',
    inline: true,
    selectable: false,
    atom: true,

    addAttributes() {
      return {
        class: {
          default: 'placeholder',
        },
        text: {
          default: '',
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: 'span.placeholder',
          getAttrs: (dom) => ({ text: dom.textContent }),
        },
      ];
    },

    renderHTML({ node, HTMLAttributes }) {
      return ['span', mergeAttributes(HTMLAttributes), node.attrs.text];
    },

    addNodeView() {
      return ({ node }) => {
        const span = document.createElement('span');
        span.classList.add('placeholder');
        span.innerHTML = `Enter your agreement text, using short codes for dynamic content. <a class="placeholder-link">Insert</a> our template if you need help getting started.`;

        span.querySelector('.placeholder-link').addEventListener('click', (event) => {
          event.preventDefault();

          if (this.editor) {
            this.editor.commands.clearContent();
            this.editor.commands.insertContent(DefaultRentalAgreementTemplate);
          }
        });

        return {
          dom: span,
        };
      };
    },
  });
